// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"fd052c63","513":"0cc2c8a7","639":"0240b005","703":"245f307d"}[chunkId] + ".chunk.js";
};